import { resolveTenantHost } from './tenantHost'

/**
 * The slug of the tenant whose host the page runs on; null on the apex and on
 * a host that is none (reserved names, other domains).
 */
export function hostTenantSlug(
  hostname: string,
  baseDomain: string,
): string | null {
  const host = resolveTenantHost(hostname, baseDomain)
  return host.kind === 'tenant' ? host.slug : null
}

/**
 * The host's tenant slug for code outside React (the `auth.me` loaders), set
 * once by `createApp`: one host per page load. The backend takes it to name
 * the host tenant's default admin language in the session.
 */
export const hostSlugRef: { current: string | null } = { current: null }

/** The `auth.me` input of this page's host. */
export const meInput = () => ({ tenantSlug: hostSlugRef.current })
